var map = {
	"./activtiy.svg": 261,
	"./alipay.svg": 5751,
	"./cart.svg": 3142,
	"./cart_empty.svg": 5217,
	"./cart_garay.svg": 2336,
	"./cart_warn.svg": 889,
	"./cdkey.svg": 7501,
	"./delete.svg": 7320,
	"./down_arrow.svg": 415,
	"./hot.svg": 791,
	"./kefu.svg": 9037,
	"./kefu_warn.svg": 5022,
	"./linux.svg": 3997,
	"./mac.svg": 7147,
	"./paypal.svg": 7493,
	"./question.svg": 2938,
	"./right_arrow_two.svg": 9267,
	"./right_green.svg": 1486,
	"./search.svg": 164,
	"./steam.svg": 241,
	"./wechat_pay.svg": 2557,
	"./weixin.svg": 7842,
	"./windows.svg": 2499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3573;